import { Injectable } from '@angular/core';
import { ApiClientHelper } from '@mpt-fo/common/core/helpers/api-client.helper';
import { ModalOptionsConfig, ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { AppConfig } from '@mpt-fo/common/shared/config/app-config';
import { DEFAULT_DIALOG_CLASSES, MONIEPOINT_DESIGN_TYPE } from '@mpt-fo/common/shared/constants';
import { BusinessTermsAndConditionsModalComponent } from '../shared/components/business-terms-and-conditions-modal/business-terms-and-conditions-modal.component';
import { PendingTermsAndConditions, TermsAndConditionsDetails } from './pos-business-tc.model';
import { Subject } from 'rxjs';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';

@Injectable({
    providedIn: 'root',
})
export class PosBusinessTermsAndConditionsService {
    private isShowPosTermsAndConditionsSubject = new Subject<boolean>();
    isShowPosTermsAndConditions$ = this.isShowPosTermsAndConditionsSubject.asObservable();
    isModalShowedOnce = false;
    isGracePeriodExpired = false;
    documentId: string;

    constructor(private apiClientHelper: ApiClientHelper, private config: AppConfig, private modal: ModalService) {}

    getAgentTermsAndConditionsStatus(params): Promise<PendingTermsAndConditions> {
        params = StringHelper.toUrlString(params);
        const url = `${this.config.MONIEPOINT_TERMINAL}/api/v1/agents/terms-and-conditions/pending?${params}`;
        return this.apiClientHelper.getForPromise(url);
    }

    getAgentTermsAndConditionsDetails(id): Promise<TermsAndConditionsDetails> {
        const url = `${this.config.MONIEPOINT_TERMINAL}/api/v1/terms-and-conditions/${id}`;
        return this.apiClientHelper.getForPromise(url);
    }

    signedPosTermsAndConditions(documentId: string, businessId: number): Promise<{ message: string; version: string }> {
        let url = this.config.MONIEPOINT_TERMINAL + `/api/v1/agents/terms-and-conditions/${documentId}/sign/${businessId}`;
        return this.apiClientHelper.postForPromise(url, {});
    }

    setIsShowPosTermsAndConditions(isShowOnce: boolean, isGracePeriodExpired = false) {
        this.isModalShowedOnce = isShowOnce;
        this.isGracePeriodExpired = isGracePeriodExpired;
        this.isShowPosTermsAndConditionsSubject.next(isShowOnce);
    }

    setDocumentId(id: string) {
        this.documentId = id;
    }

    launchTCModal(isGracePeriodExpired: boolean) {
        const config = new ModalOptionsConfig();
        config.nzComponentParams.data = { isGracePeriodExpired: isGracePeriodExpired };
        config.nzClosable = false;
        config.nzMaskClosable = false;
        config.nzKeyboard = false;
        config.className = DEFAULT_DIALOG_CLASSES + ' ' + 'tc-modal-class';
        config.hideNZTitle = true;
        config.nzComponentParams.callback = () => {};
        config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
        config.nzComponentParams.callbackName = 'Close';
        this.modal.createModal(BusinessTermsAndConditionsModalComponent, config);
    }
}
